import {
  AutomaticNamespaceProvisioningFormValues,
  AutomaticNamespaceProvisioningPolicyPayload,
  isUserScope,
} from './types';

export function buildAutomaticNamespaceProvisioningPayload(
  formData: AutomaticNamespaceProvisioningFormValues
): AutomaticNamespaceProvisioningPolicyPayload {
  if (formData.namespaceRoleId === undefined) {
    throw new Error('A namespace role is required');
  }

  return {
    UserScopes: formData.userScopes.filter(isUserScope),
    NamespacePattern: formData.namespacePattern,
    NamespaceRoleID: formData.namespaceRoleId,
  };
}
